import { sqliteTable, text } from "drizzle-orm/sqlite-core";
import { users } from "./users";

// ============================================================================
// activity_logs — บันทึกทุกการเปลี่ยนแปลง
// ============================================================================
export const activityLogs = sqliteTable("core_activity_logs", {
  id: text("id").primaryKey(), // ULID
  module: text("module").notNull(), // module ที่เกิดเหตุ
  doctype: text("doctype").notNull(), // ชื่อ doctype (e.g. "booking", "invoice")
  documentId: text("document_id").notNull(), // ID ของ document
  action: text("action").notNull(), // created / updated / deleted / state_changed / commented
  summary: text("summary"), // สรุปสั้นๆ
  description: text("description"), // รายละเอียดกิจกรรม (call, email, note, meeting)
  changes: text("changes"), // JSON: [{field, old, new}]
  userId: text("user_id").notNull().references(() => users.id), // FK → users
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

// Type exports
export type ActivityLog = typeof activityLogs.$inferSelect;
export type NewActivityLog = typeof activityLogs.$inferInsert;
